import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ScrollTeaser from '@/app/[locale]/about-us/_components/ScrollTeaser';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import RichText from '@/app/components/RichText';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

const MembershipHero = () => {
  const t = useTranslations();
  const path = usePathname();

  return (
    <section
      className="relative pt-[20vh] md:px-5 md:pt-[8vh] md:pb-12 lg:pt-[10vh]"
      data-cy="membership-hero"
    >
      <LayoutGrid className="h-full content-between gap-y-8">
        <GridItem
          colStart={{ sm: 'main', md: 5, lg: 5 }}
          colEnd={{ sm: 'main', md: 20, lg: 20 }}
        >
          <Typography
            Element="h1"
            variant="h1"
            height="tight"
            data-cy="membership-hero-title"
          >
            {t('membership_hero_title')}
          </Typography>
        </GridItem>
        <GridItem
          colStart={{ sm: 'main', md: 13, lg: 13 }}
          colEnd={{ sm: 'main', md: 20, lg: 20 }}
          className="pb-2 lg:pb-7"
        >
          <Typography
            variant="h5"
            className="text-xl lg:text-3xl"
            weight="light"
            height="relaxed"
            data-cy="membership-hero-subtitle"
          >
            <RichText messageKey="membership_hero_subtitle" />
          </Typography>
          <Button
            className="mt-6"
            link="true"
            href={STORE_POP_PATHNAME}
            variant="secondary-dark"
            size="large"
            data-cy="membership-hero-cta"
            onClick={async () => {
              await window.ouraAnalytics.track(EventType.CTAClicked, {
                cta: 'Start Your Oura Journey',
                location: 'Hero',
                path: path,
              });
            }}
          >
            {t('membership_hero_cta')}
          </Button>
        </GridItem>
        <GridItem
          className="h-full"
          colStart={{ sm: 'full', md: 5, lg: 5 }}
          colEnd={{ sm: 'full', md: 'full', lg: 'full' }}
          rowEnd={{ sm: 4 }}
          rowStart={{ sm: 3 }}
        >
          <div className="relative aspect-2000/1017 w-full">
            <ArtDirectionImage
              srcSet={[
                {
                  src: 'membership/jade/hero',
                  media: '(max-width: 767px)',
                },
                {
                  src: 'membership/jade/hero',
                  media: '(min-width: 768px)',
                },
              ]}
              localizedAlt="membership_jade_hero_alt"
              fill
              className="rounded-3xl object-contain"
            />
          </div>
        </GridItem>
        <ScrollTeaser />
      </LayoutGrid>
    </section>
  );
};

export default MembershipHero;
